import React from 'react';

import styled, { css }  from 'styled-components';

import settings from '../global/settings';
import Container from './Container';
import VideoRow from './VideoRow';
import * as SharedStyles from '../global/SharedStyles';
const { StTitle, StLink } = SharedStyles;
import CustomLink from './CustomLink';

const StStyleBlock = styled.section`
    @media (min-width: ${settings.bp.medium.view}) {
        position: relative;
        z-index: 10;
        margin-top: -70px;
        ${({ noOverlap }) => {
            return noOverlap ? 'margin-top: 0px;' : '';
        }}

         ${props =>
                props.tripleRepair &&
                css`
                margin-left: 36px;
                margin-right: 36px;
                `}

    }


    .container {
        max-width: 670px;
        padding: 20px 0;
         ${props =>
                props.tripleRepair &&
                css`
                margin-left: 0px;
                margin-right: 0px;
                  width: 100% !important;
                  padding: 0px;
                `}
        ${props =>
                props.platinum &&
                css`
                max-width: unset;
                `}


        @media (min-width: ${settings.bp.medium.view}) {
         max-width: 100%;
         width: 100%;
         ${props =>
                !props.tripleRepair &&
                css`
                    border-bottom: 1px solid ${settings.color.gray1};
            background-color: #fff;
            box-shadow: 0 2px 51px 0 rgba(171, 171, 171, 0.06);
            max-width: 1070px;
             padding: 42px 92px 72px;
                `};
            
        }
    }

    h2 {
        line-height: 1.67;
        font-size: 18px;
        font-weight: normal;
        letter-spacing: 0.07em;
        margin: 0 0 20px;
    }
    ${props =>
        props.platinum &&
        css`
        margin-left: 0%;
        margin-right: 0%;
        `}

    @media (min-width: ${settings.bp.medium.view}) {
        ${props =>
        props.platinum &&
        css`
        margin-left: 5%;
        margin-right: 5%;
        `}
    }
`;

const StStyleBlockTop = styled.div`
    margin-bottom: 50px;
    text-align: center;

    @media (min-width: ${settings.bp.small.view}) {
        margin-bottom: 70px;
    }

    h1 {
        margin-bottom: 0;
    }
`;

const StStyleBlockBottom = styled.div`
    .StLink {
        text-align: center;
        margin-top: 40px;
    }

    .StVideoRow {
        margin-bottom: 0;
    }
`;

export default function StyleBlock(props) {
    const {
        title,
        subTitle,
        linkText,
        linkHref,
        linkMobileText,
        linkMobileMore,
        items,
        noOverlap,
        larger,
        tripleRepair,
        platinum,
    } = props;
    const singleItem = items && items.length === 1;
    return (
        <StStyleBlock 
        tripleRepair={tripleRepair || platinum}
        platinum={platinum}
        noOverlap={noOverlap}>
            <Container singleItem={singleItem} larger={larger} unsetMaxWidth={platinum}>
                {title ||
                    subTitle ||
                    (linkText && (
                        <StStyleBlockTop>
                            {title && (
                                <StTitle>
                                    <h1>{title}</h1>
                                </StTitle>
                            )}
                            {subTitle && <h2>{title}</h2>}
                            {linkText && linkHref && (
                                <StLink>
                                    <CustomLink href={linkHref}>
                                        {linkText}
                                    </CustomLink>
                                </StLink>
                            )}
                        </StStyleBlockTop>
                    ))}
                <StStyleBlockBottom>
                    {items && <VideoRow tripleRepair={tripleRepair || platinum} platinum={platinum} items={items} />}
                    {linkMobileText && linkMobileMore && (
                        <StLink className="only-mobile">
                            <CustomLink href={linkMobileMore}>
                                {linkMobileText}
                            </CustomLink>
                        </StLink>
                    )}
                </StStyleBlockBottom>
            </Container>
        </StStyleBlock>
    );
}
